import {
  Text,
  Collapse,
  ListItem,
  UnorderedList,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import { memo, useMemo } from 'react';

import IconButton from 'shared/IconButton';
import { breakpoints } from 'app/themeConfig';

const CompactDesign = ({ labels, activeLabel = null, onLabelClick }) => {
  const { isOpen, onToggle } = useDisclosure();
  const [isLaptop] = useMediaQuery(`(min-width: ${breakpoints.laptop})`);

  const actualLabels = useMemo(
    () => [activeLabel, ...labels.filter(i => i !== activeLabel)],
    [activeLabel, labels],
  );

  return (
    <Collapse in={isOpen} startingHeight={isLaptop ? '54px' : '48px'} style={{ width: '100%' }}>
      <UnorderedList
        w="full"
        styleType="none"
        display="flex"
        flexDir="column"
        gap={{ mobile: '10px', laptop: '20px' }}
        m="0"
      >
        {actualLabels?.map((label, i) => {
          const isActiveLabel = label === activeLabel;

          return (
            <ListItem
              key={i}
              w="full"
              h={{ mobile: '48px', laptop: '54px' }}
              px="24px"
              pos="relative"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexShrink="0"
              cursor="pointer"
              transition="all .2s"
              bgColor={isActiveLabel && 'bg.accent'}
              borderRadius="full"
              _hover={{ laptop: { bgColor: !isActiveLabel && 'bg.grayLight' } }}
              onClick={() => {
                !isActiveLabel && onLabelClick(label);
                onToggle();
              }}
            >
              <Text
                textStyle="h2"
                fontSize={{ mobile: '12px', laptop: '18px' }}
                pos="relative"
                zIndex="10"
              >
                {label}
              </Text>

              {isActiveLabel && (
                <IconButton
                  direction="down"
                  border="none"
                  boxSize="unset"
                  iconProps={{
                    boxSize: { laptop: '20px', mobile: '24px' },
                    transform: !isOpen && 'translateY(2px)',
                  }}
                  transform={isOpen && 'rotate(180deg) '}
                  disableHover
                  cursor="pointer"
                />
              )}
            </ListItem>
          );
        })}
      </UnorderedList>
    </Collapse>
  );
};

export const SwitcherCompactDesign = memo(CompactDesign);
